import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { GetPairingCodeInfoError } from "../../ajax/cloud";

export default function FailureDialog({ isOpen, onOkClick, errorMessage }) {
  const { t } = useTranslation();
  let text;
  let heading;
  switch (errorMessage) {
    case GetPairingCodeInfoError.codeNotFound:
      text = t(`pairing.manually.enterCode.failureDialog.codeNotFound.text`);
      heading = t(
        `pairing.manually.enterCode.failureDialog.codeNotFound.heading`
      );
      break;
    case GetPairingCodeInfoError.codeExpired:
      text = t(`pairing.manually.enterCode.failureDialog.codeExpired.text`);
      heading = t(
        `pairing.manually.enterCode.failureDialog.codeExpired.heading`
      );
      break;
    default:
      text = t(`pairing.failureDialog.text`);
      heading = t(`pairing.failureDialog.heading`);
      break;
  }

  const button = {
    text: t("buttons.ok"),
    onClick: onOkClick
  };

  return (
    <Dialog
      isOpen={isOpen}
      type="failure"
      buttons={[button]}
      heading={heading}
      text={text}
    />
  );
}
